/* import __COLOCATED_TEMPLATE__ from './user-stat.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { equal } from "@ember/object/computed";
import TEMPLATE from "./user-stat.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({
  classNames: ["user-stat"],
  type: "number",
  isNumber: equal("type", "number"),
  isDuration: equal("type", "duration")
}));